module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-723-retro-min.10247c83.jpg";